
import { ofArray, singleton as singleton_1, sortBy, sortByDescending } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { maxValue, compare } from "../../fable_modules/fable-library-js.5.3.0/Date.js";
import { compare as compare_1 } from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { renderBrowse, ListState } from "./ChallengeList.js";
import { equals } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { fontWeight_fontBold, fontSize_text3Xl, display_block, display_hidden, margin_mb6, gap_gap$002D3, alignItems_itemsCenter, justifyContent_justifyBetween, flexDirection_flexRow, flexDirection_flexCol, padding_py8, padding_px8, padding_px6, margin_mxAuto, maxWidth_w7Xl, gap_gap$002D2, display_flex, backgroundColor_bgNeutral200, backgroundColor_bgNeutral100, transition_transitionColors, borderRadius_roundedMd, fontWeight_fontMedium, fontSize_textSm, padding_py2, padding_px4, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { textColor_textNeutral900, md, lg, sm, hover, textColor_textNeutral700, textColor_textOnPrimary, backgroundColor_bgPrimary600 } from "../TailwindExtensions.js";
import { ClientTypes_Route, ClientTypes_SupportOthersSort, ClientTypes_Msg } from "../ClientTypes.js";
import { view as view_1 } from "../Pledge/MyPledgesView.js";

export function sortChallenges(sort, challenges) {
    switch (sort.tag) {
        case 1:
            return sortByDescending((c_1) => c_1.StartDate, challenges, {
                Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
            });
        case 2:
            return sortByDescending((c_2) => c_2.TargetAmount, challenges, {
                Compare: (x_2, y_2) => (compare_1(x_2, y_2) | 0),
            });
        default:
            return sortBy((c) => defaultArg(c.EndDate, maxValue()), challenges, {
                Compare: (x, y) => (compare(x, y) | 0),
            });
    }
}

function sortedState(model) {
    const matchValue = model.PublicChallenges;
    if (matchValue.tag === 2) {
        return new ListState(2, [sortChallenges(model.SupportOthersSort, matchValue.fields[0])]);
    }
    else {
        return matchValue;
    }
}

function sortButton(label, sort, currentSort, dispatch) {
    const isActive = equals(sort, currentSort);
    return HtmlHelper_createElement("button", ofArray([["className", tw(toList(delay(() => append(singleton(padding_px4), delay(() => append(singleton(padding_py2), delay(() => append(singleton(fontSize_textSm), delay(() => append(singleton(fontWeight_fontMedium), delay(() => append(singleton(borderRadius_roundedMd), delay(() => append(singleton(transition_transitionColors), delay(() => (isActive ? append(singleton(backgroundColor_bgPrimary600), delay(() => singleton(textColor_textOnPrimary))) : append(singleton(backgroundColor_bgNeutral100), delay(() => append(singleton(textColor_textNeutral700), delay(() => singleton(hover(backgroundColor_bgNeutral200))))))))))))))))))))))], ["children", singleton_1(label)], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(74, [sort]));
    }]]));
}

function sortControls(model, dispatch) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, gap_gap$002D2]))], ["children", [sortButton("Ending Soon", new ClientTypes_SupportOthersSort(0, []), model.SupportOthersSort, dispatch), sortButton("Newest", new ClientTypes_SupportOthersSort(1, []), model.SupportOthersSort, dispatch), sortButton("Largest Goal", new ClientTypes_SupportOthersSort(2, []), model.SupportOthersSort, dispatch)]]]));
}

export function view(model, dispatch) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([maxWidth_w7Xl, margin_mxAuto, padding_px4, sm(padding_px6), lg(padding_px8), padding_py8]))], ["children", [view_1(model, dispatch), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, md(flexDirection_flexRow), md(justifyContent_justifyBetween), md(alignItems_itemsCenter), gap_gap$002D3, margin_mb6]))], ["children", [HtmlHelper_createElement("h1", ofArray([["className", tw(ofArray([display_hidden, md(display_block), fontSize_text3Xl, fontWeight_fontBold, textColor_textNeutral900]))], ["children", singleton_1("Support Others")]])), sortControls(model, dispatch)]]])), renderBrowse(sortedState(model), () => {
        dispatch(new ClientTypes_Msg(72, []));
    }, (id) => {
        dispatch(new ClientTypes_Msg(37, [new ClientTypes_Route(2, [id])]));
    }, (action) => {
        if (action.tag === 1) {
        }
        else {
            dispatch(new ClientTypes_Msg(37, [new ClientTypes_Route(2, [action.fields[0]])]));
        }
    }, model.PledgeLookup)]]]));
}

//# sourceMappingURL=ChallengesView.js.map
